/**
 * 阿里云 SLS WebTracking 配置
 *
 * 使用前需要在阿里云日志服务控制台：
 * 1. 创建 Project
 * 2. 创建 Logstore
 * 3. 开启 WebTracking（匿名直传模式）
 */

export const SLS_CONFIG = {
  /** 日志服务 Project 名称 */
  PROJECT: "k8s-log-custom-senna",
  /** 日志服务地域 Endpoint */
  ENDPOINT: "cn-zhangjiakou.log.aliyuncs.com",
  /** 日志库名称 */
  LOGSTORE: "kada-video-fe",
} as const
